import client from '@/http'

/**
 * Client Auth API endpoints
 */
export default {
    /**
     * @param {{postcode: string}} data
     * @returns {Promise<void>}
     */
    async searchByPostcode (data) {
        try {
            const response = await client.get(`/addresses/postcode-search/${data.postcode}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{reference: string}} data
     * @returns {Promise<void>}
     */
    async getAddressDetails (data) {
        try {
            const response = await client.get(`/addresses/details/${data.reference}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
